<template>
	<div>
		<ihead :checkindex="checkindex"></ihead>
		<div class="banner-box"><h1>机构简介</h1></div>
		<mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item v-for="(item, index) in items" :key="index" :to="item.to" :disabled="item.disabled">{{item.text}}</mu-breadcrumbs-item>
			</mu-breadcrumbs>
		</mu-container>		
		<div class="introduction-box">
			<mu-container>
				<div class="introduction-tit"><h3>机构简介</h3></div>
				<div class="introduction-content" v-html='content'></div>
			</mu-container>
		</div>
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>

<script>
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import returntop from '@/components/returntop'
export default {
components: {
	ihead, ifoot, returntop
},
data (){
	return {
		id:this.$route.query.id,
		checkindex:1,
		content:'',
		items:[{
			text: '首页',
			to: '/',
			disabled: false
		}, {
			text: '机构设置',
			disabled: true
		}, {
			text: '机构简介',
			disabled: true
		}],
	}
},
created(){
	this.getInfo()
},
methods: {	
	getInfo(){
		var data = {id: this.id}
		this.$get('/article/get-article-detail', data).then(res => {
	    if(res.code == 0){
				this.content = res.data.content
			} else {
				// console.log(res.message)
			}
		})
	}
}

}
</script>
<style>
.introduction-tit h3{
	font-size: 20px;
	font-weight: 800;
	text-transform: uppercase;
	margin: 30px 0;
}
.introduction-content{
	min-height: 300px;
	font-size: 16px;
	text-align: left;
	line-height: 1.8rem;
}
@media screen and ( max-width: 768px){
	.warp {
		width: 100% !important;
		min-width: 100%;
	}
	.head-menu{
		display: none;
	}
	.head-menu-mobile{		
		float: right;
		margin-top: 20px;
		margin-right: 5%;
	}
	.head-uppr{	
		height: 60px;		
	}
	.head-logo{
		height: 60px;
	}
	.head-logo {		
		width: 70%;
	}
	.head-logo img{
		height: 50%;
		width: 80%;
		margin-top: 15px;
	}
	.introduction-content img{
		width: 100%;
	}
}
@media screen and ( max-width: 320px) {			
}
</style>
